import React from 'react';
import settings from '../settings';
import autoBind from '../modules/autoBind';
import TokenManager from './auth/TokenManager';
import logo from './assets/logo-no-text.png';
import Licenses from './licenses/Licenses.jsx';

const apiLocation = settings.apiUrl;

export default class Navbar extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      api: null
    };
    this.getApi();
  }
  handleLogout() {
    TokenManager.clearToken();
    this.props.onLogout();
  }

  getApi() {
    $.ajax(apiLocation)
    .success((api) => this.setState({ api, loggingOut: false }))
    .fail(() => this.setState({ errorMessage: 'Hubo un error al cargar la aplicación.' }));
  }

  render() {
    const consultantsTab = { url: '#/consultores', label: 'Consultores' };
    const requestsTab = { url: '#/peticiones', label: 'Peticiones' };
    const tabs = [
      { url: '#/reportes', label: 'Reportes' },
      { url: '#/clientes', label: 'Clientes' },
    ];

    if (this.props.user.userType === 'admin') {
      tabs.push(consultantsTab);
      tabs.push(requestsTab);
    }

    if (!this.state.api) {
      return null;
    }

    return (
      <nav className='navbar navbar-default' style={{ marginBottom: '30px' }}>
        <div className='container'>
          <div className='navbar-header'>
            <button onClick={() => this.forceUpdate()} type='button' className='navbar-toggle collapsed' data-toggle='collapse' data-target='#navbar' aria-expanded='false' aria-controls='navbar'>
              <span className='sr-only'>Toggle navigation</span>
              <span className='icon-bar'></span>
              <span className='icon-bar'></span>
              <span className='icon-bar'></span>
            </button>
            <a style={{ padding: '7px 20px' }} className='navbar-brand' href='#'>
              <img src={logo} height='36px' />
            </a>
          </div>
          <div id='navbar' className='navbar-collapse collapse' aria-expanded='false'>
            <ul className='nav navbar-nav'>
              {tabs.map(this.renderTab)}
            </ul>
            <ul className='nav navbar-nav navbar-right'>
              <li><a>{this.props.user.username}</a></li>
              {this.renderLicenses()}
              <li><a href='#' onClick={this.handleLogout}>Salir</a></li>
            </ul>
          </div>
        </div>
      </nav>
    );
  
  }
  renderLicenses() {
    if (this.props.user.userType !== "admin") {
      return <li><a><Licenses user={this.props.user.username} resourceUrl={this.state.api._rels.licenses}/></a></li>;
    }
  }
  renderTab(tab) {
    const isActive = this.props.route.startsWith(tab.url.substring(1));
    return <li key={tab.label} className={isActive ? 'active' : ''}><a href={tab.url}>{tab.label}</a></li>;
  }
}



// WEBPACK FOOTER //
// ./src/App/Navbar.jsx